import { SchemaType } from "../SchemaType";

export const SchemaTypeToAbiType = {
  [SchemaType.UINT8]: "uint8",
  [SchemaType.UINT16]: "uint16",
  [SchemaType.UINT24]: "uint24",
  [SchemaType.UINT32]: "uint32",
  [SchemaType.UINT40]: "uint40",
  [SchemaType.UINT48]: "uint48",
  [SchemaType.UINT56]: "uint56",
  [SchemaType.UINT64]: "uint64",
  [SchemaType.UINT72]: "uint72",
  [SchemaType.UINT80]: "uint80",
  [SchemaType.UINT88]: "uint88",
  [SchemaType.UINT96]: "uint96",
  [SchemaType.UINT104]: "uint104",
  [SchemaType.UINT112]: "uint112",
  [SchemaType.UINT120]: "uint120",
  [SchemaType.UINT128]: "uint128",
  [SchemaType.UINT136]: "uint136",
  [SchemaType.UINT144]: "uint144",
  [SchemaType.UINT152]: "uint152",
  [SchemaType.UINT160]: "uint160",
  [SchemaType.UINT168]: "uint168",
  [SchemaType.UINT176]: "uint176",
  [SchemaType.UINT184]: "uint184",
  [SchemaType.UINT192]: "uint192",
  [SchemaType.UINT200]: "uint200",
  [SchemaType.UINT208]: "uint208",
  [SchemaType.UINT216]: "uint216",
  [SchemaType.UINT224]: "uint224",
  [SchemaType.UINT232]: "uint232",
  [SchemaType.UINT240]: "uint240",
  [SchemaType.UINT248]: "uint248",
  [SchemaType.UINT256]: "uint256",

  [SchemaType.INT8]: "int8",
  [SchemaType.INT16]: "int16",
  [SchemaType.INT24]: "int24",
  [SchemaType.INT32]: "int32",
  [SchemaType.INT40]: "int40",
  [SchemaType.INT48]: "int48",
  [SchemaType.INT56]: "int56",
  [SchemaType.INT64]: "int64",
  [SchemaType.INT72]: "int72",
  [SchemaType.INT80]: "int80",
  [SchemaType.INT88]: "int88",
  [SchemaType.INT96]: "int96",
  [SchemaType.INT104]: "int104",
  [SchemaType.INT112]: "int112",
  [SchemaType.INT120]: "int120",
  [SchemaType.INT128]: "int128",
  [SchemaType.INT136]: "int136",
  [SchemaType.INT144]: "int144",
  [SchemaType.INT152]: "int152",
  [SchemaType.INT160]: "int160",
  [SchemaType.INT168]: "int168",
  [SchemaType.INT176]: "int176",
  [SchemaType.INT184]: "int184",
  [SchemaType.INT192]: "int192",
  [SchemaType.INT200]: "int200",
  [SchemaType.INT208]: "int208",
  [SchemaType.INT216]: "int216",
  [SchemaType.INT224]: "int224",
  [SchemaType.INT232]: "int232",
  [SchemaType.INT240]: "int240",
  [SchemaType.INT248]: "int248",
  [SchemaType.INT256]: "int256",

  [SchemaType.BYTES1]: "bytes1",
  [SchemaType.BYTES2]: "bytes2",
  [SchemaType.BYTES3]: "bytes3",
  [SchemaType.BYTES4]: "bytes4",
  [SchemaType.BYTES5]: "bytes5",
  [SchemaType.BYTES6]: "bytes6",
  [SchemaType.BYTES7]: "bytes7",
  [SchemaType.BYTES8]: "bytes8",
  [SchemaType.BYTES9]: "bytes9",
  [SchemaType.BYTES10]: "bytes10",
  [SchemaType.BYTES11]: "bytes11",
  [SchemaType.BYTES12]: "bytes12",
  [SchemaType.BYTES13]: "bytes13",
  [SchemaType.BYTES14]: "bytes14",
  [SchemaType.BYTES15]: "bytes15",
  [SchemaType.BYTES16]: "bytes16",
  [SchemaType.BYTES17]: "bytes17",
  [SchemaType.BYTES18]: "bytes18",
  [SchemaType.BYTES19]: "bytes19",
  [SchemaType.BYTES20]: "bytes20",
  [SchemaType.BYTES21]: "bytes21",
  [SchemaType.BYTES22]: "bytes22",
  [SchemaType.BYTES23]: "bytes23",
  [SchemaType.BYTES24]: "bytes24",
  [SchemaType.BYTES25]: "bytes25",
  [SchemaType.BYTES26]: "bytes26",
  [SchemaType.BYTES27]: "bytes27",
  [SchemaType.BYTES28]: "bytes28",
  [SchemaType.BYTES29]: "bytes29",
  [SchemaType.BYTES30]: "bytes30",
  [SchemaType.BYTES31]: "bytes31",
  [SchemaType.BYTES32]: "bytes32",

  [SchemaType.BOOL]: "bool",
  [SchemaType.ADDRESS]: "address",

  [SchemaType.UINT8_ARRAY]: "uint8[]",
  [SchemaType.UINT16_ARRAY]: "uint16[]",
  [SchemaType.UINT24_ARRAY]: "uint24[]",
  [SchemaType.UINT32_ARRAY]: "uint32[]",
  [SchemaType.UINT40_ARRAY]: "uint40[]",
  [SchemaType.UINT48_ARRAY]: "uint48[]",
  [SchemaType.UINT56_ARRAY]: "uint56[]",
  [SchemaType.UINT64_ARRAY]: "uint64[]",
  [SchemaType.UINT72_ARRAY]: "uint72[]",
  [SchemaType.UINT80_ARRAY]: "uint80[]",
  [SchemaType.UINT88_ARRAY]: "uint88[]",
  [SchemaType.UINT96_ARRAY]: "uint96[]",
  [SchemaType.UINT104_ARRAY]: "uint104[]",
  [SchemaType.UINT112_ARRAY]: "uint112[]",
  [SchemaType.UINT120_ARRAY]: "uint120[]",
  [SchemaType.UINT128_ARRAY]: "uint128[]",
  [SchemaType.UINT136_ARRAY]: "uint136[]",
  [SchemaType.UINT144_ARRAY]: "uint144[]",
  [SchemaType.UINT152_ARRAY]: "uint152[]",
  [SchemaType.UINT160_ARRAY]: "uint160[]",
  [SchemaType.UINT168_ARRAY]: "uint168[]",
  [SchemaType.UINT176_ARRAY]: "uint176[]",
  [SchemaType.UINT184_ARRAY]: "uint184[]",
  [SchemaType.UINT192_ARRAY]: "uint192[]",
  [SchemaType.UINT200_ARRAY]: "uint200[]",
  [SchemaType.UINT208_ARRAY]: "uint208[]",
  [SchemaType.UINT216_ARRAY]: "uint216[]",
  [SchemaType.UINT224_ARRAY]: "uint224[]",
  [SchemaType.UINT232_ARRAY]: "uint232[]",
  [SchemaType.UINT240_ARRAY]: "uint240[]",
  [SchemaType.UINT248_ARRAY]: "uint248[]",
  [SchemaType.UINT256_ARRAY]: "uint256[]",

  [SchemaType.INT8_ARRAY]: "int8[]",
  [SchemaType.INT16_ARRAY]: "int16[]",
  [SchemaType.INT24_ARRAY]: "int24[]",
  [SchemaType.INT32_ARRAY]: "int32[]",
  [SchemaType.INT40_ARRAY]: "int40[]",
  [SchemaType.INT48_ARRAY]: "int48[]",
  [SchemaType.INT56_ARRAY]: "int56[]",
  [SchemaType.INT64_ARRAY]: "int64[]",
  [SchemaType.INT72_ARRAY]: "int72[]",
  [SchemaType.INT80_ARRAY]: "int80[]",
  [SchemaType.INT88_ARRAY]: "int88[]",
  [SchemaType.INT96_ARRAY]: "int96[]",
  [SchemaType.INT104_ARRAY]: "int104[]",
  [SchemaType.INT112_ARRAY]: "int112[]",
  [SchemaType.INT120_ARRAY]: "int120[]",
  [SchemaType.INT128_ARRAY]: "int128[]",
  [SchemaType.INT136_ARRAY]: "int136[]",
  [SchemaType.INT144_ARRAY]: "int144[]",
  [SchemaType.INT152_ARRAY]: "int152[]",
  [SchemaType.INT160_ARRAY]: "int160[]",
  [SchemaType.INT168_ARRAY]: "int168[]",
  [SchemaType.INT176_ARRAY]: "int176[]",
  [SchemaType.INT184_ARRAY]: "int184[]",
  [SchemaType.INT192_ARRAY]: "int192[]",
  [SchemaType.INT200_ARRAY]: "int200[]",
  [SchemaType.INT208_ARRAY]: "int208[]",
  [SchemaType.INT216_ARRAY]: "int216[]",
  [SchemaType.INT224_ARRAY]: "int224[]",
  [SchemaType.INT232_ARRAY]: "int232[]",
  [SchemaType.INT240_ARRAY]: "int240[]",
  [SchemaType.INT248_ARRAY]: "int248[]",
  [SchemaType.INT256_ARRAY]: "int256[]",

  [SchemaType.BYTES1_ARRAY]: "bytes1[]",
  [SchemaType.BYTES2_ARRAY]: "bytes2[]",
  [SchemaType.BYTES3_ARRAY]: "bytes3[]",
  [SchemaType.BYTES4_ARRAY]: "bytes4[]",
  [SchemaType.BYTES5_ARRAY]: "bytes5[]",
  [SchemaType.BYTES6_ARRAY]: "bytes6[]",
  [SchemaType.BYTES7_ARRAY]: "bytes7[]",
  [SchemaType.BYTES8_ARRAY]: "bytes8[]",
  [SchemaType.BYTES9_ARRAY]: "bytes9[]",
  [SchemaType.BYTES10_ARRAY]: "bytes10[]",
  [SchemaType.BYTES11_ARRAY]: "bytes11[]",
  [SchemaType.BYTES12_ARRAY]: "bytes12[]",
  [SchemaType.BYTES13_ARRAY]: "bytes13[]",
  [SchemaType.BYTES14_ARRAY]: "bytes14[]",
  [SchemaType.BYTES15_ARRAY]: "bytes15[]",
  [SchemaType.BYTES16_ARRAY]: "bytes16[]",
  [SchemaType.BYTES17_ARRAY]: "bytes17[]",
  [SchemaType.BYTES18_ARRAY]: "bytes18[]",
  [SchemaType.BYTES19_ARRAY]: "bytes19[]",
  [SchemaType.BYTES20_ARRAY]: "bytes20[]",
  [SchemaType.BYTES21_ARRAY]: "bytes21[]",
  [SchemaType.BYTES22_ARRAY]: "bytes22[]",
  [SchemaType.BYTES23_ARRAY]: "bytes23[]",
  [SchemaType.BYTES24_ARRAY]: "bytes24[]",
  [SchemaType.BYTES25_ARRAY]: "bytes25[]",
  [SchemaType.BYTES26_ARRAY]: "bytes26[]",
  [SchemaType.BYTES27_ARRAY]: "bytes27[]",
  [SchemaType.BYTES28_ARRAY]: "bytes28[]",
  [SchemaType.BYTES29_ARRAY]: "bytes29[]",
  [SchemaType.BYTES30_ARRAY]: "bytes30[]",
  [SchemaType.BYTES31_ARRAY]: "bytes31[]",
  [SchemaType.BYTES32_ARRAY]: "bytes32[]",

  [SchemaType.BOOL_ARRAY]: "bool[]",
  [SchemaType.ADDRESS_ARRAY]: "address[]",

  [SchemaType.BYTES]: "bytes",
  [SchemaType.STRING]: "string",
} as const satisfies Record<SchemaType, string>;
